import {Injectable} from '@angular/core';
import { Toast, ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { BrowserModule } from '@angular/platform-browser';

@Injectable()
export class ToastService {

    public config: ToasterConfig = new ToasterConfig({
        positionClass: 'toast-center'

    });
    constructor(private toasterService: ToasterService) {
        this.toasterService = toasterService;
    }

    modifiedToast() {
        var toast: Toast = {
            type: 'info',
            title: 'description',
            body: 'modified data successfully'
        };

        this.toasterService.pop(toast);
    }
    addedToast() {
        var toast: Toast = {
            type: 'info',
            title: 'description',
            body: 'items added successfully'
        };

        this.toasterService.pop(toast);
    }

}


// WEBPACK FOOTER //
// ./src/app/providers/toast.ts